import { getSodium } from '../utils/general'

export type Base64Variant = 'urlsafe-no-padding' | 'urlsafe' | 'original-no-padding' | 'original'

const resolveVariant = (
  sodium: Awaited<ReturnType<typeof getSodium>>,
  variant: Base64Variant | undefined
) => {
  switch (variant) {
    case 'urlsafe':
      return sodium.base64_variants.URLSAFE
    case 'original-no-padding':
      return sodium.base64_variants.ORIGINAL_NO_PADDING
    case 'original':
      return sodium.base64_variants.ORIGINAL
    case 'urlsafe-no-padding':
    case undefined:
      return sodium.base64_variants.URLSAFE_NO_PADDING
  }
}

export const toBase64 = async (input: Uint8Array | string, variant?: Base64Variant) => {
  const sodium = await getSodium()

  return sodium.to_base64(input, resolveVariant(sodium, variant))
}

export const fromBase64 = async (input: string, variant?: Base64Variant) => {
  const sodium = await getSodium()

  return sodium.from_base64(input, resolveVariant(sodium, variant))
}

export const toText = async (input: Uint8Array) => {
  const sodium = await getSodium()

  return sodium.to_string(input)
}

export const fromHex = async (input: string) => {
  const sodium = await getSodium()

  return sodium.from_hex(input)
}

export const toHex = async (input: Uint8Array) => {
  const sodium = await getSodium()

  return sodium.to_hex(input)
}
